class SearchLogsReq{

    constructor() {
  
      this.id = undefined;
      this.fromDate = undefined;
      this.toDate = undefined;
      this.message = undefined;
      this.userName = undefined;
      this.logType = undefined;
      this.request = undefined;
      this.response = undefined;
      this.route = undefined;
      this.userId = undefined;
      
      this.pagingParams = {
        pageNumber: undefined,
        pageSize: undefined
      }
    }
  }
  export default SearchLogsReq;